// Import dependencies
import { builderFetch } from '@builder/core/utilities';
const { isEmpty } = _uo.utility;

// Translatable strings
const strings = UncannyAutomator._core.i18n.core.itemLoop.createNew;

/**
 * Adds a new loop to the current recipe
 *
 * @param {Object} iterableExpression Defines the default iterable expression of the loop
 * @param {("users"|"posts"|"token")} iterableExpression.type The elements that have to be iterated
 * @param {String} [iterableExpression.value] Only required if `.type` is "token", the token itself
 * @param {String} [iterableExpression.value_html] Only required if `.type` is "token", the HTML of the token
 * @return {Promise} The apiFetch promise
 */
const createLoop = ( iterableExpression ) => {
	// If the item is not define, stop here
	if ( isEmpty( iterableExpression ) ) {
		throw new Error( `createLoop: The iterable expression must be defined` );
	}

	// Save the recipe title
	return builderFetch( {
		endpoint: `loop/${ UncannyAutomator._recipe.recipe_id }`,
		method: 'POST',
		data: {
			action: 'add_loop_block',
			// eslint-disable-next-line camelcase
			iterable_expression: iterableExpression
		},
		snackbar: {
			loading: strings.creatingLoop,
			success: strings.loopCreated,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/item/loop/create-loop', {
				detail: {
					actionsConditions: filters
				}
			} ) );
		}

		return response;
	} );
}

export default createLoop;
